import DesignManagerLogoBlack from '../src/DesignManagerLogoBlack';
export default DesignManagerLogoBlack;
